import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const zoleoDevice= {
  getList,
  storeOrUpdate,
  search,
  positionDevice,
  destroy,
  assignUserToDevice,
  setDeviceTime,
  getStopDeviceAlarmRequests,
  updateAlarmStatus
};

function getList(propertyId = null){
  return (
    axios
      .get(
        `${apiEndpoint.zoleoDevice}?property_id=${propertyId}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 ){
          return res.data;
        }
      })
  );
}

function search(propertyId,s){
  return (
    axios
      .get(
        `${apiEndpoint.zoleoDevice}/search?property_id=${propertyId}&s=${s}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}
function positionDevice(propertyId){
  return (
    axios
      .get(
        `${apiEndpoint.zoleoDevice}/position-device?property_id=${propertyId}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}


function storeOrUpdate(data, id = null){
  return (id ? (
    axios
      .put(
        apiEndpointFunction.zoleoDevice(id),
        data,
        {
          headers: authHeader(),
        }
      )
  ) : (
    axios
      .post(
        apiEndpoint.zoleoDevice,
        data,
        {
          headers: authHeader()
        }
      )
  )).then(res => {
    if(res && res.status === 200){
      return res.data;
    }
    return {};
  });
}

function destroy(id){
  return (
    axios
      .delete(
        apiEndpointFunction.zoleoDevice(id),
        {
          headers: authHeader()
        }
      ).then(res => {
        if (res && res.status === 200) {
          return res.data;
        }
      })
  );
}

function assignUserToDevice(deviceId, userId){
  return (
    axios
      .post(
        `${apiEndpoint.zoleoDevice}/${deviceId}/assign-user-to-device`,
        {
          user_id: userId
        },
        {
          headers: authHeader()
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}

function setDeviceTime(deviceId, deviceTime){
  return (
    axios
      .post(
        `${apiEndpoint.zoleoDevice}/${deviceId}/set-device-time`,
        {
          device_time: deviceTime
        },
        {
          headers: authHeader()
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}

function getStopDeviceAlarmRequests(id){
  return (
    axios
      .get(
        `${apiEndpoint.zoleoDevice}/${id}/get-stop-device-alarm-requests`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200 ){
          return res.data;
        }
      })
  );
}

function updateAlarmStatus(id, status){
  return (
    axios
      .post(
        `${apiEndpoint.zoleoDevice}/${id}/update-alarm-status`,
        {
          status
        },
        {
          headers: authHeader()
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}
